import React from 'react'
import styled, { useTheme } from 'styled-components'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import { Search } from 'react-feather'

const StyledTextField = styled(TextField)`
  &.MuiTextField-root {
    width: 100%;
    .MuiInputBase-input {
      font-family: SpaceGroteskBold;
      color: ${({ theme }) => theme.colors.white};
      ::placeholder {
        opacity: 1;
        color: ${({ theme, disabled }) => (disabled ? theme.colors.yellow : theme.colors.white4)};
      }
    }
    .MuiFilledInput-root {
      border: none;
      background-color: ${({ theme }) => theme.colors.gray8};
      border-radius: 8px;
      height: 39px;
      .MuiFilledInput-input {
        padding: 16px 6px;
      }
      &.Mui-focused {
        border: 1px solid ${({ theme }) => theme.colors.purple};
      }
      &.MuiFilledInput-underline:before {
        border-bottom: unset;
      }
      &.MuiFilledInput-underline:after {
        border-bottom: unset;
      }
    }
    .MuiOutlinedInput-root {
      border: none;
      border: 1px solid ${({ theme }) => theme.colors.gray7};
      border-radius: 8px;
      height: 39px;
      .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      &.Mui-focused {
        border: 1px solid ${({ theme }) => theme.colors.purple};
      }
    }
  }
`

const SearchInput: React.FC<TextFieldProps> = ({ variant, ...props }) => {
  const theme = useTheme()

  return (
    <StyledTextField
      variant={variant}
      InputProps={{
        value: props.value,
        startAdornment:
          variant === 'filled' ? (
            <InputAdornment position="start" sx={{ paddingLeft: 1, paddingBottom: 2 }}>
              <Search width={16} height={16} color={theme.colors.gray2} />
            </InputAdornment>
          ) : (
            <InputAdornment position="start">
              <Search width={20} height={20} color={theme.colors.gray2} />
            </InputAdornment>
          )
      }}
      {...props}
    >
      {props.children}
    </StyledTextField>
  )
}

export default SearchInput
